module.exports = __webpack_public_path__ + "media/images/categories/hand-7d13e7a7f96054947f487e77885dd48d.png";